import React, { useState, useEffect } from 'react';

import { useRouter } from 'next/router';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';

import Style from './ApplyJob.module.css';

import { getAssessmentQues } from '../../../redux/actions/aeAssessment';
import { searchResume } from '../../../redux/actions/aeMyProfile';

import { isEmpty } from '../../../utils/generic';

import AssessmentMob from './AssessmentMob';
import Education from './Education';
import ProfessionalDetails from './ProfessionalDetails';
import Resume from './Resume';
import Submit from './Submit';
import WordDetails from './WorkDetails';

function ApplyJobMobModal({ closeModal, toggleModal, open }) {
  const { job_details } = useSelector((state) => state);
  const router = useRouter();
  const dispatch = useDispatch();

  // determines section in the application process

  const [section, setSection] = useState({ value: 'Resume', id: 0 });

  // for showing 3 buttons in the application process on coming back

  const [showThirdBtn, setShowThirdBtn] = useState(false);

  // profile data

  const { data } = useSelector((state) => state?.my_profile);

  // stores value of 'resume' field in profile data and application

  const [parsedData, setParsedData] = useState({});
  const [resumeLink, setResumeLink] = useState('');
  const [resume, setResume] = useState({});

  // sets filling via resume parsing as true

  const [fillViaResume, setFillViaResume] = useState(false);

  // stores value of 'work experience' field in profile data and application

  const [work, setWork] = useState();

  // stores value of 'education' field in profile data and application

  const [education, seteducation] = useState();

  // stores value of 'professional' field in profile data and application

  const [professional, setProfessional] = useState();

  // checks whether the applicant is a fresher or not

  const [fresher, setFresher] = useState(false);

  // stores value of current role and employer in profile data and application

  const [currentJob, setCurrentJob] = useState({ current_role: data?.data?.current_role, current_employer: data?.data?.current_employer });
  const { assessment_ques } = useSelector((state) => state);

  const list = assessment_ques?.data?.data?.assessment_configs?.[0]?.questions;

  useEffect(() => {
    if (!isEmpty(job_details?.data?.data?.role_code)) {
      dispatch(getAssessmentQues(job_details?.data?.data?.role_code));
    }
  }, [job_details, open]);

  useEffect(() => {
    if (!isEmpty(data) && open) {
      fetchResume();
    }
  }, [data, open]);

  const fetchResume = () => {
    const payload = {
      conditions: {
        candidate_id: {
          value: data?.data?.id,
          type: 'id',
          operator: 'eq'
        }
      }
    };

    dispatch(searchResume(payload)).then((data) => {
      const resume = data?.data?.resumes?.[0];

      // setUploadedDate(resume?.updated_at);
      // setFileName(resume?.file_name);

      setResume(resume);
      setParsedData(resume?.parsed_data);
      setResumeLink(resume?.resume_link);
    });
  };

  return (
    <Modal
      className='mobAppModalContainer '
      isOpen={open}
      onHide={() => {
        if (section?.id >= 4) {
          router.reload();
        } else {
          setSection({ value: 'Resume', id: 0 });
          setResumeLink('');
          setResume({});
          setWork();
          setProfessional();
          seteducation();
          setFresher(false);
          setFillViaResume(false);
          setCurrentJob({ current_role: data?.data?.current_role, current_employer: data?.data?.current_employer });
          closeModal();
        }
      }}
      toggle={() => {
        if (section?.id >= 4) {
          router.reload();
        } else {
          setSection({ value: 'Resume', id: 0 });
          setResumeLink('');
          setResume({});
          setWork();
          setProfessional();
          seteducation();
          setFresher(false);
          setFillViaResume(false);
          setCurrentJob({ current_role: data?.data?.current_role, current_employer: data?.data?.current_employer });
          toggleModal();
        }
      }}
    >
      <ModalBody className='relativePos full-height-imp'>
        <div
          className={`${Style.CloseBtn} pointer`}
          onClick={() => {
            if (section?.id >= 4) {
              router.reload();
            } else {
              setSection({ value: 'Resume', id: 0 });
              setResumeLink('');
              setResume({});
              setWork();
              setProfessional();
              seteducation();
              setFresher(false);
              setFillViaResume(false);
              setCurrentJob({ current_role: data?.data?.current_role, current_employer: data?.data?.current_employer });
              closeModal();
            }
          }}
        >
          <img src='/images/Apply/close.svg' />
        </div>
        <div className={Style.ApplicationTitle} data-testid='job-role-name'>
          {job_details?.data?.data?.job_role_name ? job_details?.data?.data?.job_role_name : job_details?.data?.data?.posting_title}
        </div>
        <div className={Style.ApplicationSubTitle}>{job_details?.data?.data?.role_code}</div>
        <div className={`flexStyleStart padding16T font-14px fw-600 ${Style.SectionHeading}`}>{section?.value}</div>
        <div className='flex-style-center padding8T'>
          <div
            className={
              section?.value === 'Resume'
                ? list
                  ? `fixedWidth-18 ${Style.selectedSection}`
                  : `fixedWidth-23 ${Style.selectedSection}`
                : list
                  ? `fixedWidth-18 ${Style.doneSection}`
                  : `fixedWidth-23 ${Style.doneSection}`
            }
          />
          <div
            className={
              section?.id === 1
                ? list
                  ? `fixedWidth-18 ${Style.selectedSection}`
                  : `fixedWidth-23 ${Style.selectedSection}`
                : section?.id > 1
                  ? list
                    ? `fixedWidth-18 ${Style.doneSection}`
                    : `fixedWidth-23 ${Style.doneSection}`
                  : list
                    ? `fixedWidth-18 ${Style.unselectedSection}`
                    : `fixedWidth-23 ${Style.unselectedSection}`
            }
          />
          <div
            className={
              section?.id === 2
                ? list
                  ? `fixedWidth-18 ${Style.selectedSection}`
                  : `fixedWidth-23 ${Style.selectedSection}`
                : section?.id > 2
                  ? list
                    ? `fixedWidth-18 ${Style.doneSection}`
                    : `fixedWidth-23 ${Style.doneSection}`
                  : list
                    ? `fixedWidth-18 ${Style.unselectedSection}`
                    : `fixedWidth-23 ${Style.unselectedSection}`
            }
          />
          <div
            className={
              section?.id === 3
                ? list
                  ? `fixedWidth-18 ${Style.selectedSection}`
                  : `fixedWidth-23 ${Style.selectedSection}`
                : section?.id > 3
                  ? list
                    ? `fixedWidth-18 ${Style.doneSection}`
                    : `fixedWidth-23 ${Style.doneSection}`
                  : list
                    ? `fixedWidth-18 ${Style.unselectedSection}`
                    : `fixedWidth-23 ${Style.unselectedSection}`
            }
          />
          {list ? (
            <div
              className={
                section?.id === 4 ? `fixedWidth-18 ${Style.selectedSection}` : section?.id > 4 ? `fixedWidth-18 ${Style.doneSection}` : `fixedWidth-18 ${Style.unselectedSection}`
              }
            />
          ) : null}
        </div>
        {/* <div className={Style.DetailWindow}> */}
        {section?.value === 'Resume' ? (
          <Resume
            fetchResume={fetchResume}
            fillViaResume={fillViaResume}
            resume={resume}
            resumeLink={resumeLink}
            setCurrentJob={setCurrentJob}
            setFillViaResume={setFillViaResume}
            setResume={setResume}
            setResumeLink={setResumeLink}
            setSection={setSection}
            showThirdBtn={showThirdBtn}
            userDetails={data?.data}
          />
        ) : section?.value === 'Work Details' ? (
          <WordDetails
            currentJob={currentJob}
            fillViaResume={fillViaResume}
            fresher={fresher}
            parsedData={parsedData}
            setCurrentJob={setCurrentJob}
            setFillViaResume={setFillViaResume}
            setFresher={setFresher}
            setSection={setSection}
            setShowThirdBtn={setShowThirdBtn}
            setWork={setWork}
            userDetails={data?.data}
            work={work}
          />
        ) : section?.value === 'Educational Details' ? (
          <Education education={education} fillViaResume={fillViaResume} parsedData={parsedData} setSection={setSection} seteducation={seteducation} userDetails={data?.data} />
        ) : section?.value === 'Professional Details' ? (
          <ProfessionalDetails
            currentJob={currentJob}
            education={education}
            fillViaResume={fillViaResume}
            fresher={fresher}
            list={list}
            parsedData={parsedData}
            professional={professional}
            resume={resume}
            resumeLink={resumeLink}
            setProfessional={setProfessional}
            setSection={setSection}
            userDetails={data?.data}
            work={work}
          />
        ) : section?.value === 'Assessment' ? (
          <AssessmentMob
            currentJob={currentJob}
            education={education}
            parsedData={parsedData}
            professional={professional}
            resume={resume}
            resumeLink={resumeLink}
            setSection={setSection}
            userDetails={data?.data}
            work={work}
          />
        ) : (
          <Submit />
        )}
        {/* </div> */}
      </ModalBody>
    </Modal>
  );
}

export default ApplyJobMobModal;
